export function MdiDockRight(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-5 14H4V6h11Z"></path></svg>);
}

export function MdiDockBottom(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 9H4V6h16Z"></path></svg>);
}